import moment from 'moment';
import cloneDeep from 'lodash.clonedeep';

const createCurrency = (value, code) => {
  return {
    value,
    code,
  };
};

const initOrder = () => ({
  shipByDateTime: '',
  paidDateTime: moment(),
  holdUntilDateTime: '',
  orderDateTime: moment(),
  items: [],
  amountSummary: {
    shippingPaid: createCurrency(0, 'USD'),
    taxPaid: createCurrency(0, 'USD'),
    totalPaid: createCurrency(0, 'USD'),
  },
  soldTo: {
    email: '',
    name: '',
    phone: '',
  },
  isGift: false,
  shipToAddress: {
    name: '',
    company: '',
    phone: '',
    line1: '',
    line2: '',
    line3: '',
    city: '',
    state: '',
    postalCode: '',
    countryCode: 'US',
    residentialIndicator: 'Unknown',
  },
  orderNumber: '',
  createGuid: '',
  store: {
    storeGuid: '',
  },
});

export const createEmptyOrder = (countryCode, currencyCode) => {
  const emptyOrder = initOrder();
  const clonedEmptyOrder = cloneDeep(emptyOrder);

  return {
    ...clonedEmptyOrder,
    amountSummary: {
      shippingPaid: createCurrency(clonedEmptyOrder.amountSummary.shippingPaid.Value, currencyCode),
      taxPaid: createCurrency(clonedEmptyOrder.amountSummary.taxPaid.Value, currencyCode),
      totalPaid: createCurrency(clonedEmptyOrder.amountSummary.totalPaid.Value, currencyCode),
    },
    shipToAddress: {
      ...emptyOrder.ShipToAddress,
      countryCode: countryCode || emptyOrder.shipToAddress.countryCode,
    },
  };
};

const emptyItem = {
  isGift: false,
  name: '',
  productId: null,
  productThumbnailUrl: null,
  quantityFulfilled: 0,
  quantity: 1,
  quantityOrdered: 1,
  quantityPlanned: 0,
  quantityReturned: 0,
  salesOrderItemId: null,
  sku: '',
  totalPrice: createCurrency(0, 'USD'),
  unitPrice: createCurrency(0, 'USD'),
};

export const createEmptyItem = (currencyCode) => {
  const clonedEmptyItem = cloneDeep(emptyItem);

  return {
    ...clonedEmptyItem,
    totalPrice: createCurrency(clonedEmptyItem.totalPrice.value, currencyCode),
    unitPrice: createCurrency(clonedEmptyItem.unitPrice.value, currencyCode),
  };
};
